import React, { useEffect, useState } from "react";
import { FormikProvider, useFormik, Form, Field, ErrorMessage, FieldArray } from "formik";
import * as bie from "react-bootstrap";
import { ImagePdfBucket } from "../CommonUtils/ImagesBase64";
import * as Yup from "yup";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { config } from "../CommonUtils/CommonURLS";
import { emailValidation, mobileValidation } from "../CommonYupValidations";
import allowNumbersOnly, { allowAlphabetAndSpacesOnly } from "../CommonUtils/CommonValidations";
import Swal from "sweetalert2";

export default function NewCollegeApplication() {

    const booleanRadioFields = [
        "isOtherInstitution",
        "isTempCollege",
        "hasCriminalRecord",
        "isUgcNotRecognized",
        "hasDuesComplaints",
        "isOwnLand",
        "isLandContiguous",
        "isBuildingPlanApproved",
        "isNearRestrictedArea",
        "isImproperBuilding",
        "isOtherInstitutionBuilding",
        "isParkingAvailable",
        "isParkingSize20Percent",
        "isPlaygroundAvailable",
        "hasAlternativePlayground"
    ];
    const mapYesNoToBoolean = (formValues) => {
        const payload = { ...formValues };

        booleanRadioFields.forEach((fieldName) => {
            if (payload[fieldName] === "Yes") {
                payload[fieldName] = true;
            } else if (payload[fieldName] === "No") {
                payload[fieldName] = false;
            }
        });

        return payload;
    };
    const [DistrictList, setDistrictList] = useState([]);
    const [MandalList, setMandalLists] = useState({
        societyMandal: [],
        collegeMandal: [],
        collegeAddressMandal: [],
        landMandal: [],
        landRegisterMandal: [],
        buildingMandal: []
    });
    const [vilglist, setVillageLists] = useState({
        landVillage: [],
        buildingVillage: [],
    });
    const GetVillageData = async (distcode, mdlcode, fieldKey) => {
        try {
            const res = await CommonAxiosGet(
                `${config.url.FAC_URL}getvillagesOld/${distcode}/${mdlcode}`
            );

            const data =
                res?.data?.scode === "01" ? res?.data?.villagemst || [] : [];

            setVillageLists((prev) => ({
                ...prev,
                [fieldKey]: data,
            }));
        } catch (err) {
            console.error(err);
        }
    };
    function GetDistrictData() {
        CommonAxiosGet(`${config.url.FAC_URL}getdistrictsOld`).then((res) => {
            setDistrictList(res?.data?.scode === "01" ? res.data.districtmst || [] : []);
        });
    }
    const GetMandalData = async (distcode, fieldKey) => {
        try {
            const res = await CommonAxiosGet(`${config.url.FAC_URL}getmandalsOld/${distcode}`);
            const data = res?.data?.scode === "01" ? res.data.mandalmst || [] : [];

            setMandalLists(prev => ({
                ...prev,
                [fieldKey]: data
            }));
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => { GetDistrictData(); }, []);


    const CollegevalidationSchema = Yup.object({
        // UploadPaymentReceipt: Yup.mixed().required("Required"),
        // ===== SOCIETY =====
        societyName: Yup.string().required("Required"),

        societyRegCertificate: Yup.mixed().required("Required"),
        societyBylaws: Yup.mixed().required("Required"),

        societyStreet: Yup.string().required("Required"),
        societyMandal: Yup.string().required("Required"),
        societyDistrict: Yup.string().required("Required"),
        societyMobile: mobileValidation,

        isOtherInstitution: Yup.string().required("Required"),
        otherInstitutionDetails: Yup.string().when("isOtherInstitution", {
            is: "Yes",
            then: (schema) => schema.required("Required")
        }),

        isTempCollege: Yup.string().required("Required"),
        tempCollegeDetails: Yup.string().when("isTempCollege", {
            is: "Yes",
            then: (schema) => schema.required("Required")
        }),

        hasCriminalRecord: Yup.string().required("Required"),
        criminalRecordDetails: Yup.string().when("hasCriminalRecord", {
            is: "Yes",
            then: (schema) => schema.required("Required")
        }),

        isUgcNotRecognized: Yup.string().required("Required"),
        ugcNotRecognizedDetails: Yup.string().when("isUgcNotRecognized", {
            is: "Yes",
            then: (schema) => schema.required("Required")
        }),

        hasDuesComplaints: Yup.string().required("Required"),
        duesComplaintsDetails: Yup.string().when("hasDuesComplaints", {
            is: "Yes",
            then: (schema) => schema.required("Required")
        }),

        // ===== COLLEGE =====
        proposedCollegeName: Yup.string().required("Required"),

        collegeDistrict: Yup.string().required("Required"),
        collegeMandal: Yup.string().required("Required"),

        collegeSurveyNo: Yup.string().required("Required"),
        collegeDoorNo: Yup.string().required("Required"),
        collegeStreet: Yup.string().required("Required"),
        collegeAddressMandal: Yup.string().required("Required"),
        collegeAddressDistrict: Yup.string().required("Required"),
        mandalStatus: Yup.string().required("Required"),
        collegeMobile: mobileValidation,
        collegeEmail: emailValidation,

        // Secretary
        secretaryName: Yup.string().required("Required"),
        secretaryDesignation: Yup.string().required("Required"),
        secretaryAddress: Yup.string().required("Required"),
        secretaryMobile: mobileValidation,
        secretaryEmail: emailValidation,

        // Principal
        principalName: Yup.string().required("Required"),
        principalDesignation: Yup.string().required("Required"),
        principalAddress: Yup.string().required("Required"),
        principalMobile: mobileValidation,
        principalEmail: emailValidation,

        // ===== LAND =====
        isOwnLand: Yup.string().required("Required"),

        landExtent: Yup.string().when("isOwnLand", {
            is: "Yes",
            then: (schema) => schema.required("Required")
        }),

        landSurveyNo: Yup.string().when("isOwnLand", {
            is: "Yes",
            then: (schema) => schema.required("Required")
        }),

        landVillage: Yup.string().when("isOwnLand", {
            is: "Yes",
            then: (schema) => schema.required("Required")
        }),

        landMandal: Yup.string().when("isOwnLand", {
            is: "Yes",
            then: (schema) => schema.required("Required")
        }),

        landDistrict: Yup.string().when("isOwnLand", {
            is: "Yes",
            then: (schema) => schema.required("Required")
        }),

        landRegisteredDoc: Yup.mixed().when("isOwnLand", {
            is: "Yes",
            then: (schema) => schema.required("Required")
        }),

        landRegisterMandal: Yup.string().when("isOwnLand", {
            is: "Yes",
            then: (schema) => schema.required("Required")
        }),

        landSketchDoc: Yup.mixed().when("isOwnLand", {
            is: "Yes",
            then: (schema) => schema.required("Required")
        }),

        isLandContiguous: Yup.string().when("isOwnLand", {
            is: "Yes",
            then: (schema) => schema.required("Required")
        }),

        nonContiguousDetails: Yup.string().when("isLandContiguous", {
            is: "No",
            then: (schema) => schema.required("Required")
        }),

        landDistance: Yup.string().when("isLandContiguous", {
            is: "No",
            then: (schema) => schema.required("Required")
        }),

        // Building Details 
        typeOfAccommodation: Yup.string().required("Required"),
        buildingSurveyNo: Yup.string().required("Required"),
        buildingDoorNo: Yup.string().required("Required"),
        buildingVillage: Yup.string().required("Required"),
        buildingMandal: Yup.string().required("Required"),
        buildingDistrict: Yup.string().required("Required"),

        buildingRegDoc: Yup.mixed().required("Required"),
        buildingRegDate: Yup.string().required("Required"),

        isBuildingPlanApproved: Yup.string().required("Required"),
        competentAuthority: Yup.string().when("isBuildingPlanApproved", {
            is: "Yes",
            then: (s) => s.required("Required")
        }),

        buildingPlanDoc: Yup.mixed().required("Required"),
        buildingCarpetArea: Yup.string().required("Required"),

        constructionPermissionDoc: Yup.mixed().required("Required"),

        isNearRestrictedArea: Yup.string().required("Required"),
        isImproperBuilding: Yup.string().required("Required"),

        buildingCompletionDoc: Yup.mixed().required("Required"),
        sanitaryCertificate: Yup.mixed().required("Required"),
        geoTaggedPhotos: Yup.mixed().required("Required"),

        isOtherInstitutionBuilding: Yup.string().required("Required"),

        annexureDoc: Yup.mixed().required("Required"),

        isParkingAvailable: Yup.string().required("Required"),
        isParkingSize20Percent: Yup.string().when("isParkingAvailable", {
            is: "Yes",
            then: (s) => s.required("Required")
        }),
        parkingProofDoc: Yup.mixed().when("isParkingAvailable", {
            is: "No",
            then: (s) => s.required("Required")
        }),

        isPlaygroundAvailable: Yup.string().required("Required"),
        playgroundExtent: Yup.string().when("isPlaygroundAvailable", {
            is: "Yes",
            then: (s) => s.required("Required")
        }),
        playgroundDoc: Yup.mixed().when("isPlaygroundAvailable", {
            is: "Yes",
            then: (s) => s.required("Required")
        }),
        hasAlternativePlayground: Yup.string().when("isPlaygroundAvailable", {
            is: "No",
            then: (s) => s.required("Required")
        }),
        playgroundMouDoc: Yup.mixed().when("hasAlternativePlayground", {
            is: "Yes",
            then: (s) => s.required("Required")
        }),

        fireSafetyDoc: Yup.mixed().required("Required"),

        ugPrograms: Yup.array().of(
            Yup.object({
                programName: Yup.string().required("Required"),
                majorName: Yup.string().required("Required"),
                medium: Yup.string().required("Required"),
            })
        ),

        financialResources: Yup.array().of(
            Yup.object({
                amount: Yup.string().required("Required"),
                periodFrom: Yup.string().required("Required"),
                periodTo: Yup.string().required("Required"),
                fdrNo: Yup.string().required("Required"),
                date: Yup.string().required("Required"),
                bankName: Yup.string().required("Required"),
                ifscCode: Yup.string().required("Required"),
                fdrFile: Yup.mixed().required("Required"),
            })
        ),

        corpusFundDetails: Yup.array().of(
            Yup.object({
                programme: Yup.string().required("Required"),
                amount: Yup.string().required("Required"),
                periodFrom: Yup.string().required("Required"),
                periodTo: Yup.string().required("Required"),
                fdrNo: Yup.string().required("Required"),
                date: Yup.string().required("Required"),
                bankName: Yup.string().required("Required"),
                ifscCode: Yup.string().required("Required"),
                maturityDate: Yup.string().required("Required"),
                renewalDate: Yup.string().required("Required"),
                fdrFile: Yup.mixed().required("Required")
            })
        ),
        dprDocument: Yup.mixed().required("Required"),
        developmentPlanDoc: Yup.mixed().required("Required"),
        // architecturalPlanDoc: Yup.mixed().required("Required"),
        governanceStructureDoc: Yup.mixed().required("Required"),
        financeSourceDoc: Yup.mixed().required("Required"),
        facultyPoliciesDoc: Yup.mixed().required("Required"),
    });

    const ApplicationFormik = useFormik({
        initialValues: {

            // ===== BASIC DETAILS =====
            // UploadPaymentReceipt: "",

            // ===== SOCIETY =====
            societyName: "",
            societyRegCertificate: "",
            societyBylaws: "",

            societyDoorNo: "",
            societyStreet: "",
            societyMandal: "",
            societyDistrict: "",
            societyMobile: "",

            isOtherInstitution: "",
            otherInstitutionDetails: "",

            isTempCollege: "",
            tempCollegeDetails: "",

            hasCriminalRecord: "",
            criminalRecordDetails: "",

            isUgcNotRecognized: "",
            ugcNotRecognizedDetails: "",

            hasDuesComplaints: "",
            duesComplaintsDetails: "",


            // ===== COLLEGE =====
            proposedCollegeName: "",

            collegeDistrict: "",
            collegeMandal: "",

            collegeSurveyNo: "",
            collegeDoorNo: "",
            collegeStreet: "",
            collegeAddressMandal: "",
            collegeAddressDistrict: "",
            collegeMobile: "",
            collegeEmail: "",
            mandalStatus: "", // Rural / Urban / Tribal

            // ==Contact Details==
            // Secretary
            secretaryName: "",
            secretaryDesignation: "",
            secretaryAddress: "",
            secretaryMobile: "",
            secretaryEmail: "",

            // Principal
            principalName: "",
            principalDesignation: "",
            principalAddress: "",
            principalMobile: "",
            principalEmail: "",

            // ===== LAND DETAILS =====
            isOwnLand: "",
            landExtent: "",
            landSurveyNo: "",
            landVillage: "",
            landMandal: "",
            landDistrict: "",

            landRegisteredDoc: "",

            landRegisterMandal: "",

            landSketchDoc: "",

            isLandContiguous: "",

            nonContiguousDetails: "",
            landDistance: "",

            //Building Details
            typeOfAccommodation: "",
            buildingSurveyNo: "",
            buildingDoorNo: "",
            buildingVillage: "",
            buildingMandal: "",
            buildingDistrict: "",

            buildingRegDoc: "",
            buildingRegDate: "",

            isBuildingPlanApproved: "",
            competentAuthority: "",

            buildingPlanDoc: "",
            buildingCarpetArea: "",

            constructionPermissionDoc: "",


            isNearRestrictedArea: "",
            isImproperBuilding: "",

            buildingCompletionDoc: "",
            sanitaryCertificate: "",
            geoTaggedPhotos: "",

            isOtherInstitutionBuilding: "",

            annexureDoc: "",

            // Parking
            isParkingAvailable: "",
            isParkingSize20Percent: "",
            parkingProofDoc: "",

            // Playground
            isPlaygroundAvailable: "",
            playgroundExtent: "",
            playgroundDoc: "",
            hasAlternativePlayground: "",
            playgroundMouDoc: "",

            fireSafetyDoc: "",

            ugPrograms: [
                {
                    programName: "",
                    majorName: "",
                    medium: ""
                }
            ],

            financialResources: [
                {
                    amount: "",
                    periodFrom: "",
                    periodTo: "",
                    fdrNo: "",
                    date: "",
                    bankName: "",
                    ifscCode: "",
                    fdrFile: ""
                }
            ],

            corpusFundDetails: [
                {
                    programme: "",
                    amount: "",
                    periodFrom: "",
                    periodTo: "",
                    fdrNo: "",
                    date: "",
                    bankName: "",
                    ifscCode: "",
                    maturityDate: "",
                    renewalDate: "",
                    fdrFile: ""
                }
            ],

            dprDocument: "",
            developmentPlanDoc: "",
            // architecturalPlanDoc: "",
            governanceStructureDoc: "",
            financeSourceDoc: "",
            facultyPoliciesDoc: "",
        },
        // validationSchema: CollegevalidationSchema,
        onSubmit: async (values) => {
            const updatedValues = {
                ...values,
                ...mapYesNoToBoolean(values)
            };
            console.log("values", updatedValues);
            try {
                const response = await CommonAxiosPost(`${config.url.FAC_URL}CollegeApplication`, updatedValues);
                if (response?.data?.scode === "01") {
                    Swal.fire(response?.data?.sdesc || "Application submitted successfully!", "success");
                    // ApplicationFormik.resetForm();
                } else {
                    InfoAlert(response?.data?.sdesc || "Failed to submit application", "error");
                }
            } catch (error) {
                console.error("Error submitting application:", error);
                InfoAlert("Error submitting application. Please try again.", "error");
            }
        }
    });
    function clearVillagesFunc(fieldName) {
        ApplicationFormik.setFieldValue(fieldName, "");
        // dispatch({ type: "VILLAGES_LIST", payload: [] });
    }
    return (
        <div className="faculty-form-wrapper">
            <h5 className="mb-3 innerheader-new">
                <span>New College Application Details</span>
            </h5>
            <div className="faculty-card">
                <FormikProvider value={ApplicationFormik}>
                    <Form className="form_adjust" onSubmit={ApplicationFormik.handleSubmit} onChange={ApplicationFormik.handleChange} >
                        {/* ================= BASIC DETAILS ================= */}
                        {/* <h5 className="mb-3 innerheader-new">
                            <span>Basic Details</span>
                        </h5>
                        <div className="form-control mb-3 mt-3">
                            <bie.Row>
                                <bie.Col lg={3} className="mb-2 mt-2">
                                    <label>Upload Payment Receipt(Registration, Processing & Inspection Fees)</label>
                                    <input type="file" className="form-control"
                                        onChange={(e) => {
                                            let filename = `UploadPaymentReceipt`;
                                            let path = "/Uploads/AffiliationPDFs/2023/";
                                            ImagePdfBucket(e, ApplicationFormik, path, `UploadPaymentReceipt`, filename, "pdf");
                                        }}
                                    />

                                    <ErrorMessage name="UploadPaymentReceipt" component="div" className="text-danger" />
                                </bie.Col>
                            </bie.Row>
                        </div> */}
                        {/* ================= SOCIETY ================= */}
                        <h5 className="mb-3 innerheader-new">
                            <span>Society Details</span>
                        </h5>
                        <div className="form-control mb-3 mt-3">
                            <bie.Row className="mt-3">
                                <bie.Col lg={3} className="mb-3">
                                    <label>Name of the Sponsoring Society</label>
                                    <Field type="text" name="societyName" className="form-control" onKeyPress={allowAlphabetAndSpacesOnly} />
                                    <ErrorMessage name="societyName" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col lg={3} className="mb-3">
                                    <label>Registration Certificate</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        onChange={(e) => {
                                            let filename = `societyRegCertificate`;
                                            let path = "/Uploads/AffiliationPDFs/2023/";
                                            ImagePdfBucket(e, ApplicationFormik, path, `societyRegCertificate`, filename, "pdf");
                                        }}
                                    />
                                    <ErrorMessage name="societyRegCertificate" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col lg={3} className="mb-3">
                                    <label>Bye-laws of the Society</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        onChange={(e) => {
                                            let filename = `societyBylaws`;
                                            let path = "/Uploads/AffiliationPDFs/2023/";
                                            ImagePdfBucket(e, ApplicationFormik, path, `societyBylaws`, filename, "pdf");
                                        }}
                                    />
                                    <ErrorMessage name="societyBylaws" component="div" className="text-danger" />
                                </bie.Col>
                                <bie.Col lg={3} className="mb-3">
                                    <label>Mobile Number</label>
                                    <Field type="tel" name="societyMobile" className="form-control" maxLength={10} onKeyPress={allowNumbersOnly} />
                                    <ErrorMessage name="societyMobile" component="div" className="text-danger" />
                                </bie.Col>
                            </bie.Row>
                            {/* <h8 className="mb-2">Address</h8> */}
                            <bie.Row >
                                <bie.Col lg={3} className="mb-3">
                                    <label>District</label>
                                    <Field as="select" name="societyDistrict" className="form-control"
                                        onChange={(e) => { GetMandalData(e?.target?.value, "societyMandal"); }}
                                    >
                                        <option value="">---select---</option>
                                        {DistrictList?.map((d) => (
                                            <option key={d.dist_code} value={d.dist_code}>
                                                {d.dist_name}
                                            </option>
                                        ))}
                                    </Field>
                                    <ErrorMessage name="societyDistrict" component="div" className="text-danger" />
                                </bie.Col>


                                <bie.Col lg={3} className="mb-3">
                                    <label>Mandal</label>
                                    <Field as="select" name="societyMandal" className="form-control">
                                        <option value="">---select---</option>
                                        {MandalList?.societyMandal?.map((d) => (
                                            <option key={d.mandal_code} value={d.mandal_code}>
                                                {d.mandal_name}
                                            </option>
                                        ))}
                                    </Field>
                                    <ErrorMessage name="societyMandal" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col lg={3} className="mb-3">
                                    <label>Street</label>
                                    <Field type="text" name="societyStreet" className="form-control" />
                                    <ErrorMessage name="societyStreet" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col lg={3} className="mb-3">
                                    <label>Door No</label>
                                    <Field type="text" name="societyDoorNo" className="form-control" />
                                    <ErrorMessage name="societyDoorNo" component="div" className="text-danger" />
                                </bie.Col>
                            </bie.Row>
                            <bie.Row>
                                <bie.Col lg={3} className="mb-3">
                                    <label>Any other Educational Institution?</label>
                                    <div className="d-flex gap-3">
                                        <label>
                                            <Field type="radio" name="isOtherInstitution" value="Yes" className="form-check-input me-1" />
                                            Yes
                                        </label>
                                        <label>
                                            <Field type="radio" name="isOtherInstitution" value="No" className="form-check-input me-1"
                                                onChange={() => { ApplicationFormik.setFieldValue("otherInstitutionDetails", ""); }} />
                                            No
                                        </label>
                                    </div>
                                    <ErrorMessage name="isOtherInstitution" component="div" className="text-danger" />
                                </bie.Col>

                                {ApplicationFormik.values.isOtherInstitution === "Yes" && (
                                    <bie.Col lg={3} className="mb-3">
                                        <label>Details of other institutions</label>
                                        <Field type="text" name="otherInstitutionDetails" className="form-control" />
                                        <ErrorMessage name="otherInstitutionDetails" component="div" className="text-danger" />
                                    </bie.Col>
                                )}
                                {/* </bie.Row>
                            <bie.Row> */}
                                <bie.Col lg={3} className="mb-3">
                                    <label>Temporary Degree College?</label>
                                    <div className="d-flex gap-3">
                                        <label>
                                            <Field type="radio" name="isTempCollege" value="Yes" className="form-check-input me-1" />
                                            Yes
                                        </label>
                                        <label>
                                            <Field type="radio" name="isTempCollege" value="No" className="form-check-input me-1"
                                                onChange={() => { ApplicationFormik.setFieldValue("tempCollegeDetails", ""); }} />
                                            No
                                        </label>
                                    </div>
                                    <ErrorMessage name="isTempCollege" component="div" className="text-danger" />
                                </bie.Col>

                                {ApplicationFormik.values.isTempCollege === "Yes" && (
                                    <bie.Col lg={3} className="mb-3">
                                        <label>Details of Temporary Degree College</label>
                                        <Field type="text" name="tempCollegeDetails" className="form-control" />
                                        <ErrorMessage name="tempCollegeDetails" component="div" className="text-danger" />
                                    </bie.Col>
                                )}
                                {/* </bie.Row>
                            <bie.Row> */}

                                <bie.Col lg={3} className="mb-3">
                                    <label>Criminal Record?</label>
                                    <div className="d-flex gap-3">
                                        <label>
                                            <Field type="radio" name="hasCriminalRecord" value="Yes" className="form-check-input me-1" />
                                            Yes
                                        </label>
                                        <label>
                                            <Field type="radio" name="hasCriminalRecord" value="No" className="form-check-input me-1" />
                                            No
                                        </label>
                                    </div>
                                    <ErrorMessage name="hasCriminalRecord" component="div" className="text-danger" />
                                </bie.Col>

                                {(ApplicationFormik.values.hasCriminalRecord === "Yes" || ApplicationFormik.values.hasCriminalRecord === "No") && (
                                    <bie.Col lg={3} className="mb-3">
                                        <label>Details of Criminal record</label>
                                        <Field type="text" name="criminalRecordDetails" className="form-control" />
                                        <ErrorMessage name="criminalRecordDetails" component="div" className="text-danger" />
                                    </bie.Col>
                                )}
                                {/* </bie.Row>
                            <bie.Row> */}
                                <bie.Col lg={3} className="mb-3">
                                    <label>UGC Not Recognized?</label>
                                    <div className="d-flex gap-3">
                                        <label>
                                            <Field type="radio" name="isUgcNotRecognized" value="Yes" className="form-check-input me-1" />
                                            Yes
                                        </label>
                                        <label>
                                            <Field type="radio" name="isUgcNotRecognized" value="No" className="form-check-input me-1" />
                                            No
                                        </label>
                                    </div>
                                    <ErrorMessage name="isUgcNotRecognized" component="div" className="text-danger" />
                                </bie.Col>

                                {(ApplicationFormik.values.isUgcNotRecognized === "Yes" || ApplicationFormik.values.isUgcNotRecognized === "No") && (
                                    <bie.Col lg={3} className="mb-3">
                                        <label>Details of UGC Not Recognized</label>
                                        <Field type="text" name="ugcNotRecognizedDetails" className="form-control" />
                                        <ErrorMessage name="ugcNotRecognizedDetails" component="div" className="text-danger" />
                                    </bie.Col>
                                )}
                                {/* </bie.Row>
                            <bie.Row> */}
                                <bie.Col lg={3} className="mb-3">
                                    <label>Dues / Complaints?</label>
                                    <div className="d-flex gap-3">
                                        <label>
                                            <Field type="radio" name="hasDuesComplaints" value="Yes" className="form-check-input me-1" />
                                            Yes
                                        </label>
                                        <label>
                                            <Field type="radio" name="hasDuesComplaints" value="No" className="form-check-input me-1" />
                                            No
                                        </label>
                                    </div>
                                    <ErrorMessage name="hasDuesComplaints" component="div" className="text-danger" />
                                </bie.Col>

                                {(ApplicationFormik.values.hasDuesComplaints === "Yes" || ApplicationFormik.values.hasDuesComplaints === "No") && (
                                    <bie.Col lg={3} className="mb-3">
                                        <label>Details of Dues / Complaints</label>
                                        <Field type="text" name="duesComplaintsDetails" className="form-control" />
                                        <ErrorMessage name="duesComplaintsDetails" component="div" className="text-danger" />
                                    </bie.Col>
                                )}
                            </bie.Row>
                        </div>
                        {/* ================= COLLEGE ================= */}
                        <h5 className="mb-3 innerheader-new mt-4">
                            <span>College Details</span>
                        </h5>
                        <div className="form-control mb-3 mt-3">
                            <bie.Row className="mt-3">
                                <bie.Col lg={3} className="mb-3">
                                    <label>Name of the Proposed College</label>
                                    <Field type="text" name="proposedCollegeName" className="form-control" onKeyPress={allowAlphabetAndSpacesOnly} />
                                    <ErrorMessage name="proposedCollegeName" component="div" className="text-danger" />
                                </bie.Col>
                                {/* </bie.Row>
                            <bie.Row> */}
                                <bie.Col lg={3} className="mb-3">
                                    <label>Proposed College District</label>
                                    <Field as="select" name="collegeDistrict" className="form-control"
                                        onChange={(e) => { GetMandalData(e?.target?.value, "collegeMandal"); }}
                                    >
                                        <option value="">---select---</option>
                                        {DistrictList?.map((d) => (
                                            <option key={d.dist_code} value={d.dist_code}>
                                                {d.dist_name}
                                            </option>
                                        ))}
                                    </Field>
                                    <ErrorMessage name="collegeDistrict" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col lg={3} className="mb-3">
                                    <label>Proposed College Mandal</label>
                                    <Field as="select" name="collegeMandal" className="form-control">
                                        <option value="">---select---</option>
                                        {MandalList?.collegeMandal?.map((d) => (
                                            <option key={d.mandal_code} value={d.mandal_code}>
                                                {d.mandal_name}
                                            </option>
                                        ))}
                                    </Field>
                                    <ErrorMessage name="collegeMandal" component="div" className="text-danger" />
                                </bie.Col>
                            </bie.Row>
                            <bie.Row>
                                <label>Postal Address of Proposed College</label>
                                <bie.Col lg={3} className="mb-3">
                                    <label>Survey No</label>
                                    <Field type="text" name="collegeSurveyNo" className="form-control" />
                                    <ErrorMessage name="collegeSurveyNo" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col lg={3} className="mb-3">
                                    <label>Door No</label>
                                    <Field type="text" name="collegeDoorNo" className="form-control" />
                                    <ErrorMessage name="collegeDoorNo" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col lg={3} className="mb-3">
                                    <label>Street</label>
                                    <Field type="text" name="collegeStreet" className="form-control" />
                                    <ErrorMessage name="collegeStreet" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col lg={3} className="mb-3">
                                    <label>District</label>
                                    <Field as="select" name="collegeAddressDistrict" className="form-control"
                                        onChange={(e) => { GetMandalData(e?.target?.value, "collegeAddressMandal"); }}
                                    >
                                        <option value="">---select---</option>
                                        {DistrictList?.map((d) => (
                                            <option key={d.dist_code} value={d.dist_code}>
                                                {d.dist_name}
                                            </option>
                                        ))}
                                    </Field>
                                    <ErrorMessage name="collegeAddressDistrict" component="div" className="text-danger" />
                                </bie.Col>
                                <bie.Col lg={3} className="mb-3">
                                    <label>Mandal</label>
                                    <Field as="select" name="collegeAddressMandal" className="form-control">
                                        <option value="">---select---</option>
                                        {MandalList?.collegeAddressMandal?.map((d) => (
                                            <option key={d.mandal_code} value={d.mandal_code}>
                                                {d.mandal_name}
                                            </option>
                                        ))}
                                    </Field>
                                    <ErrorMessage name="collegeAddressMandal" component="div" className="text-danger" />
                                </bie.Col>
                                <bie.Col lg={3} className="mb-3">
                                    <label>Status of Mandal</label>
                                    <Field as="select" name="mandalStatus" className="form-control" >
                                        <option value="">-- Select --</option>
                                        <option value="Rural">Rural</option>
                                        <option value="Urban">Urban</option>
                                        <option value="Tribal">Tribal</option>
                                    </Field>
                                    <ErrorMessage name="mandalStatus" component="div" className="text-danger" />
                                </bie.Col>
                                <bie.Col lg={3} className="mb-3">
                                    <label>Mobile Number:</label>
                                    <Field type="tel" name="collegeMobile" className="form-control" maxLength={10} onKeyPress={allowNumbersOnly} />
                                    <ErrorMessage name="collegeMobile" component="div" className="text-danger" />
                                </bie.Col>
                                <bie.Col lg={3} className="mb-3">
                                    <label>Email Id:</label>
                                    <Field type="email" name="collegeEmail" className="form-control" />
                                    <ErrorMessage name="collegeEmail" component="div" className="text-danger" />
                                </bie.Col>
                            </bie.Row>
                        </div>
                        {/* ================= CONTACT DETAILS ================= */}
                        <h5 className="mb-3 innerheader-new mt-4">
                            <span>Secretary Contact Details</span>
                        </h5>
                        <div className="form-control mb-3 mt-3">
                            <bie.Row className="mt-3">
                                <bie.Col lg={4} className="mb-3">
                                    <label>Name</label>
                                    <Field type="text" name="secretaryName" className="form-control" onKeyPress={allowAlphabetAndSpacesOnly} />
                                    <ErrorMessage name="secretaryName" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col lg={4} className="mb-3">
                                    <label>Designation</label>
                                    <Field type="text" name="secretaryDesignation" className="form-control" />
                                    <ErrorMessage name="secretaryDesignation" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col lg={4} className="mb-3">
                                    <label>Mobile Number</label>
                                    <Field type="tel" name="secretaryMobile" className="form-control" maxLength={10} onKeyPress={allowNumbersOnly} />
                                    <ErrorMessage name="secretaryMobile" component="div" className="text-danger" />
                                </bie.Col>
                            </bie.Row>

                            <bie.Row>
                                <bie.Col lg={4} className="mb-3">
                                    <label>Email</label>
                                    <Field type="email" name="secretaryEmail" className="form-control" />
                                    <ErrorMessage name="secretaryEmail" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col lg={4} className="mb-3">
                                    <label>Address</label>
                                    <Field as="textarea" name="secretaryAddress" className="form-control" />
                                    <ErrorMessage name="secretaryAddress" component="div" className="text-danger" />
                                </bie.Col>
                            </bie.Row>
                        </div>
                        {/* ================= PRINCIPAL ================= */}

                        <h5 className="mb-3 innerheader-new mt-4">
                            <span>Principal Contact Details</span>
                        </h5>
                        <div className="form-control mb-3 mt-3">
                            <bie.Row className="mt-3">
                                <bie.Col lg={4} className="mb-3">
                                    <label>Name</label>
                                    <Field type="text" name="principalName" className="form-control" onKeyPress={allowAlphabetAndSpacesOnly} />
                                    <ErrorMessage name="principalName" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col lg={4} className="mb-3">
                                    <label>Designation</label>
                                    <Field type="text" name="principalDesignation" className="form-control" />
                                    <ErrorMessage name="principalDesignation" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col lg={4} className="mb-3">
                                    <label>Mobile Number</label>
                                    <Field type="tel" name="principalMobile" className="form-control" maxLength={10} onKeyPress={allowNumbersOnly} />
                                    <ErrorMessage name="principalMobile" component="div" className="text-danger" />
                                </bie.Col>
                            </bie.Row>

                            <bie.Row>
                                <bie.Col lg={4} className="mb-3">
                                    <label>Email</label>
                                    <Field type="email" name="principalEmail" className="form-control" />
                                    <ErrorMessage name="principalEmail" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col lg={4} className="mb-3">
                                    <label>Address</label>
                                    <Field as="textarea" name="principalAddress" className="form-control" />
                                    <ErrorMessage name="principalAddress" component="div" className="text-danger" />
                                </bie.Col>
                            </bie.Row>
                        </div>

                        <h5 className="mb-3 innerheader-new mt-4">
                            <span>Land Details</span>
                        </h5>

                        {/* ===== 2.1 Own Land ===== */}
                        <div className="form-control mb-3 mt-3">
                            <bie.Row className="mt-3">
                                <bie.Col lg={3} className="mb-3">
                                    <label>Whether the society has own land</label>
                                    <div className="d-flex gap-3">
                                        <label>
                                            <Field type="radio" name="isOwnLand" value="Yes" className="form-check-input me-1" />
                                            Yes
                                        </label>
                                        <label>
                                            <Field type="radio" name="isOwnLand" value="No" className="form-check-input me-1"
                                                onChange={() => {
                                                    ApplicationFormik.setFieldValue("landExtent", "");
                                                    ApplicationFormik.setFieldValue("landSurveyNo", "");
                                                    ApplicationFormik.setFieldValue("landDistrict", "");
                                                    ApplicationFormik.setFieldValue("landMandal", "");
                                                    ApplicationFormik.setFieldValue("landVillage", "");
                                                    ApplicationFormik.setFieldValue("landRegisteredDoc", "");
                                                    ApplicationFormik.setFieldValue("landRegisterMandal", "");
                                                    ApplicationFormik.setFieldValue("landSketchDoc", "");
                                                    ApplicationFormik.setFieldValue("landOtherDetails", "");
                                                    ApplicationFormik.setFieldValue("isLandContiguous", "");
                                                    ApplicationFormik.setFieldValue("nonContiguousDetails", "");
                                                    ApplicationFormik.setFieldValue("landDistance", "");
                                                }} />
                                            No
                                        </label>
                                    </div>
                                    <ErrorMessage name="isOwnLand" component="div" className="text-danger" />
                                </bie.Col>
                            </bie.Row>

                            {/* ===== Show only if YES ===== */}
                            {ApplicationFormik.values.isOwnLand === "Yes" && (
                                <>
                                    {/* ===== 2.2 Extent ===== */}
                                    <bie.Row>
                                        <bie.Col lg={3} className="mb-3">
                                            <label>Extent of land owned by the Society</label>
                                            <Field type="text" name="landExtent" className="form-control" />
                                            <ErrorMessage name="landExtent" component="div" className="text-danger" />
                                        </bie.Col>
                                    </bie.Row>

                                    {/* ===== 2.3 Land Details ===== */}
                                    <h4 className="innerheader-new mt-2">Details of the Own land </h4>
                                    <bie.Row>
                                        <bie.Col lg={3} className="mb-3">
                                            <label>Survey No</label>
                                            <Field type="text" name="landSurveyNo" className="form-control" />
                                            <ErrorMessage name="landSurveyNo" component="div" className="text-danger" />
                                        </bie.Col>
                                        <bie.Col lg={3} className="mb-3">
                                            <label>District</label>
                                            <Field as="select" name="landDistrict" className="form-control"
                                                onChange={(e) => { GetMandalData(e?.target?.value, "landMandal"); }}
                                            >
                                                <option value="">---select---</option>
                                                {DistrictList?.map((d) => (
                                                    <option key={d.dist_code} value={d.dist_code}>
                                                        {d.dist_name}
                                                    </option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name="landDistrict" component="div" className="text-danger" />
                                        </bie.Col>
                                        <bie.Col lg={3} className="mb-3">
                                            <label>Mandal</label>
                                            <Field as="select" name="landMandal" className="form-control"
                                                onChange={(e) => {
                                                    GetVillageData(ApplicationFormik?.values?.landDistrict, e?.target?.value, "landVillage");
                                                    // clearVillagesFunc("landVillage");
                                                }}>
                                                <option value="">---select---</option>
                                                {MandalList?.landMandal?.map((d) => (
                                                    <option key={d.mandal_code} value={d.mandal_code}>
                                                        {d.mandal_name}
                                                    </option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name="landMandal" component="div" className="text-danger" />
                                        </bie.Col>
                                        <bie.Col lg={3} className="mb-3">
                                            <label>Village</label>
                                            <Field as="select" name="landVillage" className="form-control mb-2">
                                                <option value="">--Select--</option>
                                                {vilglist?.landVillage !== undefined &&
                                                    vilglist?.landVillage !== null &&
                                                    vilglist?.landVillage !== "" &&
                                                    vilglist?.landVillage?.map((e, i) => {
                                                        return (
                                                            <option key={i} value={e?.village_code}>
                                                                {" "}
                                                                {e?.village_name}{" "}
                                                            </option>
                                                        );
                                                    })}
                                            </Field>
                                            {/* <Field type="text" name="landVillage" className="form-control" /> */}
                                            <ErrorMessage name="landVillage" component="div" className="text-danger" />
                                        </bie.Col>
                                    </bie.Row>

                                    {/* ===== 2.4 Upload Registered Doc ===== */}
                                    <bie.Row>
                                        <bie.Col lg={3} className="mb-3">
                                            <label>Upload Registered Document</label>
                                            <input
                                                type="file"
                                                className="form-control"
                                                onChange={(e) => {
                                                    let filename = `landRegisteredDoc`;
                                                    let path = "/Uploads/AffiliationPDFs/2023/";
                                                    ImagePdfBucket(e, ApplicationFormik, path, `landRegisteredDoc`, filename, "pdf");
                                                }}
                                            />
                                            <ErrorMessage name="landRegisteredDoc" component="div" className="text-danger" />
                                        </bie.Col>
                                    </bie.Row>

                                    {/* ===== 2.5 Mandal ===== */}
                                    <bie.Row>
                                        <bie.Col lg={3} className="mb-3">
                                            <label>Registered Mandal</label>
                                            <Field type="text" name="landRegisterMandal" className="form-control" />
                                            <ErrorMessage name="landRegisterMandal" component="div" className="text-danger" />
                                        </bie.Col>
                                    </bie.Row>

                                    {/* ===== 2.6 Sketch Upload ===== */}
                                    <bie.Row>
                                        <bie.Col lg={3} className="mb-3">
                                            <label>Upload Sketch Plan</label>
                                            <input
                                                type="file"
                                                className="form-control"
                                                onChange={(e) => {
                                                    let filename = `landSketchDoc`;
                                                    let path = "/Uploads/AffiliationPDFs/2023/";
                                                    ImagePdfBucket(e, ApplicationFormik, path, `landSketchDoc`, filename, "pdf");
                                                }}
                                            />
                                            <ErrorMessage name="landSketchDoc" component="div" className="text-danger" />
                                        </bie.Col>
                                    </bie.Row>

                                    {/* ===== 2.7 Contiguous ===== */}
                                    <bie.Row>
                                        <bie.Col lg={3} className="mb-3">
                                            <label>Whether land is contiguous</label>
                                            <div className="d-flex gap-3">
                                                <label>
                                                    <Field type="radio" name="isLandContiguous" value="Yes" className="form-check-input me-1"
                                                        onClick={() => {
                                                            ApplicationFormik.setFieldValue("nonContiguousDetails", "");
                                                            ApplicationFormik.setFieldValue("landDistance", "");
                                                        }}
                                                    />
                                                    Yes
                                                </label>
                                                <label>
                                                    <Field type="radio" name="isLandContiguous" value="No" className="form-check-input me-1" />
                                                    No
                                                </label>
                                            </div>
                                            <ErrorMessage name="isLandContiguous" component="div" className="text-danger" />
                                        </bie.Col>
                                    </bie.Row>

                                    {/* ===== If NOT Contiguous ===== */}
                                    {ApplicationFormik.values.isLandContiguous === "No" && (
                                        <bie.Row>
                                            <bie.Col lg={3} className="mb-3">
                                                <label>Details</label>
                                                <Field type="text" name="nonContiguousDetails" className="form-control" />
                                                <ErrorMessage name="nonContiguousDetails" component="div" className="text-danger" />
                                            </bie.Col>

                                            <bie.Col lg={3} className="mb-3">
                                                <label>Distance Between Bits</label>
                                                <Field type="text" name="landDistance" className="form-control" />
                                                <ErrorMessage name="landDistance" component="div" className="text-danger" />
                                            </bie.Col>
                                        </bie.Row>
                                    )}
                                </>
                            )}
                        </div>
                        {/* ================= BUILDING ================= */}
                        <h5 className="mb-3 innerheader-new mt-4">
                            <span>Building Details</span>
                        </h5>
                        <div className="form-control mb-3 mt-3">
                            <bie.Row className="mt-3">
                                <bie.Col lg={3} className="mb-3">
                                    <label>Type of college accommodation?</label>
                                    <Field as="select" name="typeOfAccommodation" className="form-control" >
                                        <option value="">-- Select --</option>
                                        <option value="Own">Own</option>
                                        <option value="Leased">Leased</option>
                                    </Field>
                                    <ErrorMessage name="typeOfAccommodation" component="div" className="text-danger" />
                                </bie.Col>
                                <bie.Col lg={3} className="mb-3">
                                    <label>Survey No</label>
                                    <Field type="text" name="buildingSurveyNo" className="form-control" />
                                    <ErrorMessage name="buildingSurveyNo" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col lg={3} className="mb-3">
                                    <label>Door No</label>
                                    <Field type="text" name="buildingDoorNo" className="form-control" />
                                    <ErrorMessage name="buildingDoorNo" component="div" className="text-danger" />
                                </bie.Col>
                                {/* </bie.Row>
                            <bie.Row> */}
                                <bie.Col lg={3} className="mb-3">
                                    <label>District</label>
                                    <Field as="select" name="buildingDistrict" className="form-control"
                                        onChange={(e) => { GetMandalData(e?.target?.value, "buildingMandal"); }}
                                    >
                                        <option value="">---select---</option>
                                        {DistrictList?.map((d) => (
                                            <option key={d.dist_code} value={d.dist_code}>
                                                {d.dist_name}
                                            </option>
                                        ))}
                                    </Field>
                                    <ErrorMessage name="buildingDistrict" component="div" className="text-danger" />
                                </bie.Col>
                                <bie.Col lg={3} className="mb-3">
                                    <label>Mandal</label>
                                    <Field as="select" name="buildingMandal" className="form-control"
                                        onChange={(e) => {
                                            GetVillageData(ApplicationFormik?.values?.buildingDistrict, e?.target?.value, "buildingVillage");
                                            // clearVillagesFunc("buildingVillage");
                                        }}>
                                        <option value="">---select---</option>
                                        {MandalList?.buildingMandal?.map((d) => (
                                            <option key={d.mandal_code} value={d.mandal_code}>
                                                {d.mandal_name}
                                            </option>
                                        ))}
                                    </Field>
                                    <ErrorMessage name="buildingMandal" component="div" className="text-danger" />
                                </bie.Col>
                                <bie.Col lg={3} className="mb-3">
                                    <label>Village</label>
                                    <Field as="select" name="buildingVillage" className="form-control mb-2">
                                        <option value="">--Select--</option>
                                        {vilglist?.buildingVillage !== undefined &&
                                            vilglist?.buildingVillage !== null &&
                                            vilglist?.buildingVillage !== "" &&
                                            vilglist?.buildingVillage?.map((e, i) => {
                                                return (
                                                    <option key={i} value={e?.village_code}>
                                                        {" "}
                                                        {e?.village_name}{" "}
                                                    </option>
                                                );
                                            })}
                                    </Field>
                                    {/* <Field type="text" name="buildingVillage" className="form-control" /> */}
                                    <ErrorMessage name="buildingVillage" component="div" className="text-danger" />
                                </bie.Col>
                                {/* </bie.Row>
                            <bie.Row> */}
                                <bie.Col lg={3} className="mb-3">
                                    <label>Building Plan Approved?</label>
                                    <div className="d-flex gap-3">
                                        <label><Field type="radio" name="isBuildingPlanApproved" value="Yes" /> Yes</label>
                                        <label><Field type="radio" name="isBuildingPlanApproved" value="No"
                                            onChange={() => { ApplicationFormik.setFieldValue("competentAuthority", ""); }} /> No</label>
                                    </div>
                                    <ErrorMessage name="isBuildingPlanApproved" component="div" className="text-danger" />
                                </bie.Col>

                                {ApplicationFormik.values.isBuildingPlanApproved === "Yes" && (
                                    <bie.Col lg={3} className="mb-3">
                                        <label>Competent Authority</label>
                                        <Field type="text" name="competentAuthority" className="form-control" />
                                        <ErrorMessage name="competentAuthority" component="div" className="text-danger" />
                                    </bie.Col>
                                )}
                                {/* </bie.Row>
                            <bie.Row> */}
                                <bie.Col lg={3} className="mb-3">
                                    <label>Upload Building Plan</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        onChange={(e) => {
                                            let filename = `buildingPlanDoc`;
                                            let path = "/Uploads/AffiliationPDFs/2023/";
                                            ImagePdfBucket(e, ApplicationFormik, path, `buildingPlanDoc`, filename, "pdf");
                                        }}
                                    />
                                    <ErrorMessage name="buildingPlanDoc" component="div" className="text-danger" />
                                </bie.Col>
                                {/* </bie.Row>
                            <bie.Row> */}
                                <bie.Col lg={3} className="mb-3">
                                    <label>Parking Available?</label>
                                    <div className="d-flex gap-3">
                                        <Field type="radio" name="isParkingAvailable" value="Yes"
                                            onChange={() => { ApplicationFormik.setFieldValue("parkingProofDoc", ""); }} /> Yes
                                        <Field type="radio" name="isParkingAvailable" value="No"
                                            onChange={() => { ApplicationFormik.setFieldValue("isParkingSize20Percent", ""); }} /> No
                                    </div>
                                    <ErrorMessage name="isParkingAvailable" component="div" className="text-danger" />
                                </bie.Col>

                                {ApplicationFormik.values.isParkingAvailable === "Yes" && (
                                    <bie.Col lg={3} className="mb-3">
                                        <label>20% Area Provided?</label>
                                        <div className="d-flex gap-3">
                                            <Field type="radio" name="isParkingSize20Percent" value="Yes" /> Yes
                                            <Field type="radio" name="isParkingSize20Percent" value="No" /> No
                                        </div>
                                        <ErrorMessage name="isParkingSize20Percent" component="div" className="text-danger" />
                                    </bie.Col>
                                )}

                                {ApplicationFormik.values.isParkingAvailable === "No" && (
                                    <bie.Col lg={3} className="mb-3">
                                        <label>Upload Parking Proof</label>
                                        <input
                                            type="file" className="form-control"
                                            onChange={(e) => {
                                                let filename = `parkingProofDoc`;
                                                let path = "/Uploads/AffiliationPDFs/2023/";
                                                ImagePdfBucket(e, ApplicationFormik, path, `parkingProofDoc`, filename, "pdf");
                                            }}
                                        />
                                        <ErrorMessage name="parkingProofDoc" component="div" className="text-danger" />
                                    </bie.Col>
                                )}
                                {/* </bie.Row>
                            <bie.Row> */}
                                <bie.Col lg={3} className="mb-3">
                                    <label>Playground Available?</label>
                                    <div className="d-flex gap-3">
                                        <Field type="radio" name="isPlaygroundAvailable" value="Yes"
                                            onChange={() => {
                                                ApplicationFormik.setFieldValue("hasAlternativePlayground", "");
                                                ApplicationFormik.setFieldValue("playgroundMouDoc", "");
                                            }} /> Yes
                                        <Field type="radio" name="isPlaygroundAvailable" value="No"
                                            onChange={() => {
                                                ApplicationFormik.setFieldValue("playgroundExtent", "");
                                                ApplicationFormik.setFieldValue("playgroundDoc", "");
                                            }} /> No
                                    </div>
                                    <ErrorMessage name="isPlaygroundAvailable" component="div" className="text-danger" />
                                </bie.Col>

                                {ApplicationFormik.values.isPlaygroundAvailable === "Yes" && (
                                    <>
                                        <bie.Col lg={3} className="mb-3">
                                            <label>Extent (sft)</label>
                                            <Field type="text" name="playgroundExtent" className="form-control" />
                                            <ErrorMessage name="playgroundExtent" component="div" className="text-danger" />
                                        </bie.Col>

                                        <bie.Col lg={3} className="mb-3">
                                            <label>Upload Playground Doc</label>
                                            <input
                                                type="file" className="form-control"
                                                onChange={(e) => {
                                                    let filename = `playgroundDoc`;
                                                    let path = "/Uploads/AffiliationPDFs/2023/";
                                                    ImagePdfBucket(e, ApplicationFormik, path, `playgroundDoc`, filename, "pdf");
                                                }}
                                            />
                                            <ErrorMessage name="playgroundDoc" component="div" className="text-danger" />
                                        </bie.Col>
                                    </>
                                )}

                                {ApplicationFormik.values.isPlaygroundAvailable === "No" && (
                                    <>
                                        <bie.Col lg={3} className="mb-3">
                                            <label>Alternative Playground?</label>
                                            <div className="d-flex gap-3">
                                                <Field type="radio" name="hasAlternativePlayground" value="Yes" /> Yes
                                                <Field type="radio" name="hasAlternativePlayground" value="No"
                                                    onChange={() => { ApplicationFormik.setFieldValue("playgroundMouDoc", ""); }} /> No
                                            </div>
                                            <ErrorMessage name="hasAlternativePlayground" component="div" className="text-danger" />
                                        </bie.Col>

                                        {ApplicationFormik.values.hasAlternativePlayground === "Yes" && (
                                            <bie.Col lg={3} className="mb-3">
                                                <label>Upload MoU</label>
                                                <input
                                                    type="file" className="form-control"
                                                    onChange={(e) => {
                                                        let filename = `playgroundMouDoc`;
                                                        let path = "/Uploads/AffiliationPDFs/2023/";
                                                        ImagePdfBucket(e, ApplicationFormik, path, `playgroundMouDoc`, filename, "pdf");
                                                    }}
                                                />
                                                <ErrorMessage name="playgroundMouDoc" component="div" className="text-danger" />
                                            </bie.Col>
                                        )}
                                    </>
                                )}
                            </bie.Row>
                        </div>
                        <h5 className="mb-3 innerheader-new mt-4">
                            <span>Details of the Proposed programmes for starting the college.</span>
                        </h5>
                        <h4 className="mb-3 innerheader-new mt-4">Details of the UG programmes </h4>
                        <div className="table-responsive mt-3">
                            <table className="table table-bordered mt-2">

                                <thead className="table-primary">
                                    <tr>
                                        <th>SNO</th>
                                        <th>UG Programme</th>
                                        <th>Name of the Single Major </th>
                                        <th>Medium of Instruction </th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <FieldArray name="ugPrograms">
                                        {(arrayHelpers) =>
                                            arrayHelpers.form.values.ugPrograms.map((row, index) => (
                                                <tr key={index}>

                                                    <td><center>{index + 1}</center></td>

                                                    <td>
                                                        <Field
                                                            type="text"
                                                            name={`ugPrograms[${index}].programName`}
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage name={`ugPrograms[${index}].programName`} component="div" className="text-danger" />
                                                    </td>

                                                    <td>
                                                        <Field
                                                            type="text"
                                                            name={`ugPrograms[${index}].majorName`}
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage name={`ugPrograms[${index}].majorName`} component="div" className="text-danger" />
                                                    </td>

                                                    <td>
                                                        <Field
                                                            type="text"
                                                            name={`ugPrograms[${index}].medium`}
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage name={`ugPrograms[${index}].medium`} component="div" className="text-danger" />
                                                    </td>

                                                    <td align="center">
                                                        {index === 0 ? (
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-success"
                                                                onClick={() =>
                                                                    arrayHelpers.push({
                                                                        programName: "",
                                                                        majorName: "",
                                                                        medium: ""
                                                                    })
                                                                }
                                                            >
                                                                +
                                                            </button>
                                                        ) : (
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-danger"
                                                                onClick={() => arrayHelpers.remove(index)}
                                                            >
                                                                🗑
                                                            </button>
                                                        )}
                                                    </td>

                                                </tr>
                                            ))
                                        }
                                    </FieldArray>
                                </tbody>

                            </table>
                        </div>
                        <h4 className="mb-3 innerheader-new mt-4">
                            Details of Financial Resources for starting the college
                        </h4>
                        <div className="table-responsive mt-3">
                            <table className="table table-bordered mt-2">

                                <thead className="table-primary">
                                    <tr>
                                        <th>SNO</th>
                                        <th>Amount</th>
                                        <th>From</th>
                                        <th>To</th>
                                        <th>FDR No</th>
                                        <th>Date</th>
                                        <th>Bank Name</th>
                                        <th>IFSC Code</th>
                                        <th>Upload FDR</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <FieldArray name="financialResources">
                                        {(arrayHelpers) =>
                                            arrayHelpers.form.values.financialResources.map((row, index) => (
                                                <tr key={index}>

                                                    <td><center>{index + 1}</center></td>

                                                    <td>
                                                        <Field
                                                            name={`financialResources[${index}].amount`}
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage name={`financialResources[${index}].amount`} component="div" className="text-danger" />
                                                    </td>

                                                    <td>
                                                        <Field
                                                            type="date"
                                                            name={`financialResources[${index}].periodFrom`}
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage name={`financialResources[${index}].periodFrom`} component="div" className="text-danger" />
                                                    </td>

                                                    <td>
                                                        <Field
                                                            type="date"
                                                            name={`financialResources[${index}].periodTo`}
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage name={`financialResources[${index}].periodTo`} component="div" className="text-danger" />
                                                    </td>

                                                    <td>
                                                        <Field
                                                            name={`financialResources[${index}].fdrNo`}
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage name={`financialResources[${index}].fdrNo`} component="div" className="text-danger" />
                                                    </td>

                                                    <td>
                                                        <Field
                                                            type="date"
                                                            name={`financialResources[${index}].date`}
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage name={`financialResources[${index}].date`} component="div" className="text-danger" />
                                                    </td>

                                                    <td>
                                                        <Field
                                                            name={`financialResources[${index}].bankName`}
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage name={`financialResources[${index}].bankName`} component="div" className="text-danger" />
                                                    </td>

                                                    <td>
                                                        <Field
                                                            type="text"
                                                            name={`financialResources[${index}].ifscCode`}
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage name={`financialResources[${index}].ifscCode`} component="div" className="text-danger" />
                                                    </td>

                                                    <td>
                                                        <input
                                                            type="file"
                                                            className="form-control"
                                                            onChange={(e) => {
                                                                let filename = `financialResources[${index}].fdrFile`;
                                                                let path = "/Uploads/AffiliationPDFs/2023/";
                                                                ImagePdfBucket(e, ApplicationFormik, path, `financialResources[${index}].fdrFile`, filename, "pdf");
                                                            }}
                                                        />
                                                        <ErrorMessage name={`financialResources[${index}].fdrFile`} component="div" className="text-danger" />
                                                    </td>

                                                    <td align="center">
                                                        {index === 0 ? (
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-success"
                                                                onClick={() =>
                                                                    arrayHelpers.push({
                                                                        amount: "",
                                                                        periodFrom: "",
                                                                        periodTo: "",
                                                                        fdrNo: "",
                                                                        date: "",
                                                                        bankName: "",
                                                                        ifscCode: "",
                                                                        fdrFile: null
                                                                    })
                                                                }
                                                            >
                                                                +
                                                            </button>
                                                        ) : (
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-danger"
                                                                onClick={() => arrayHelpers.remove(index)}
                                                            >
                                                                🗑
                                                            </button>
                                                        )}
                                                    </td>

                                                </tr>
                                            ))
                                        }
                                    </FieldArray>
                                </tbody>

                            </table>
                        </div>
                        <h5 className="mb-3 innerheader-new mt-4">
                            <span>Details of the College Corpus Fund </span>
                        </h5>
                        <h4 className="mb-3 innerheader-new mt-4">
                            For the Proposed UG programmes /College
                        </h4>
                        <div className="table-responsive mt-3">
                            <table className="table table-bordered mt-2">

                                <thead className="table-primary">
                                    <tr>
                                        <th>SNO</th>
                                        <th>Programme</th>
                                        <th>Amount</th>
                                        <th>From</th>
                                        <th>To</th>
                                        <th>FDR No</th>
                                        <th>Date</th>
                                        <th>Bank Name</th>
                                        <th>IFSC Code</th>
                                        <th>Maturity Date</th>
                                        <th>Renewal Date</th>
                                        <th>Upload FDR</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <FieldArray name="corpusFundDetails">
                                        {(arrayHelpers) =>
                                            arrayHelpers.form.values.corpusFundDetails.map((row, index) => (
                                                <tr key={index}>

                                                    {/* SNO */}
                                                    <td><center>{index + 1}</center></td>

                                                    {/* Programme */}
                                                    <td>
                                                        <Field
                                                            type="text"
                                                            name={`corpusFundDetails[${index}].programme`}
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage name={`corpusFundDetails[${index}].programme`} component="div" className="text-danger" />
                                                    </td>

                                                    {/* Amount */}
                                                    <td>
                                                        <Field
                                                            type="text"
                                                            name={`corpusFundDetails[${index}].amount`}
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage name={`corpusFundDetails[${index}].amount`} component="div" className="text-danger" />
                                                    </td>

                                                    {/* From */}
                                                    <td>
                                                        <Field
                                                            type="date"
                                                            name={`corpusFundDetails[${index}].periodFrom`}
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage name={`corpusFundDetails[${index}].periodFrom`} component="div" className="text-danger" />
                                                    </td>

                                                    {/* To */}
                                                    <td>
                                                        <Field
                                                            type="date"
                                                            name={`corpusFundDetails[${index}].periodTo`}
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage name={`corpusFundDetails[${index}].periodTo`} component="div" className="text-danger" />
                                                    </td>

                                                    {/* FDR No */}
                                                    <td>
                                                        <Field
                                                            type="text"
                                                            name={`corpusFundDetails[${index}].fdrNo`}
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage name={`corpusFundDetails[${index}].fdrNo`} component="div" className="text-danger" />
                                                    </td>

                                                    {/* Date */}
                                                    <td>
                                                        <Field
                                                            type="date"
                                                            name={`corpusFundDetails[${index}].date`}
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage name={`corpusFundDetails[${index}].date`} component="div" className="text-danger" />
                                                    </td>

                                                    {/* Bank Details */}
                                                    <td>
                                                        <Field
                                                            type="text"
                                                            name={`corpusFundDetails[${index}].bankName`}
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage name={`corpusFundDetails[${index}].bankName`} component="div" className="text-danger" />
                                                    </td>
                                                    <td>
                                                        <Field
                                                            type="text"
                                                            name={`corpusFundDetails[${index}].ifscCode`}
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage name={`corpusFundDetails[${index}].ifscCode`} component="div" className="text-danger" />
                                                    </td>

                                                    {/* Maturity Date */}
                                                    <td>
                                                        <Field
                                                            type="date"
                                                            name={`corpusFundDetails[${index}].maturityDate`}
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage name={`corpusFundDetails[${index}].maturityDate`} component="div" className="text-danger" />
                                                    </td>

                                                    {/* Renewal Date */}
                                                    <td>
                                                        <Field
                                                            type="date"
                                                            name={`corpusFundDetails[${index}].renewalDate`}
                                                            className="form-control"
                                                        />
                                                        <ErrorMessage name={`corpusFundDetails[${index}].renewalDate`} component="div" className="text-danger" />
                                                    </td>

                                                    {/* Upload */}
                                                    <td>
                                                        <input
                                                            type="file"
                                                            className="form-control"
                                                            onChange={(e) => {
                                                                let filename = `corpusFundDetails[${index}].fdrFile`;
                                                                let path = "/Uploads/AffiliationPDFs/2023/";
                                                                ImagePdfBucket(e, ApplicationFormik, path, `corpusFundDetails[${index}].fdrFile`, filename, "pdf");
                                                            }}
                                                        />
                                                        <ErrorMessage name={`corpusFundDetails[${index}].fdrFile`} component="div" className="text-danger" />
                                                    </td>

                                                    {/* Action */}
                                                    <td align="center">
                                                        {index === 0 ? (
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-success"
                                                                onClick={() =>
                                                                    arrayHelpers.push({
                                                                        programme: "",
                                                                        amount: "",
                                                                        periodFrom: "",
                                                                        periodTo: "",
                                                                        fdrNo: "",
                                                                        date: "",
                                                                        bankName: "",
                                                                        ifscCode: "",
                                                                        maturityDate: "",
                                                                        renewalDate: "",
                                                                        fdrFile: null
                                                                    })
                                                                }
                                                            >
                                                                +
                                                            </button>
                                                        ) : (
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-danger"
                                                                onClick={() => arrayHelpers.remove(index)}
                                                            >
                                                                🗑
                                                            </button>
                                                        )}
                                                    </td>

                                                </tr>
                                            ))
                                        }
                                    </FieldArray>
                                </tbody>

                            </table>
                        </div>
                        <h5 className="mb-3 innerheader-new">
                            <span>DPR and Other relevant documents </span>
                        </h5>
                        <div className="table-responsive mt-3">
                            <table className="table table-bordered">

                                <thead className="table-primary">
                                    <tr>
                                        <th style={{ width: "10%" }}>S.No</th>
                                        <th style={{ width: "60%" }}>Document Name</th>
                                        <th style={{ width: "30%" }}>Upload</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {/* 7.1 */}
                                    <tr>
                                        <td>1</td>
                                        <td>Detailed Project Report</td>
                                        <td>
                                            <input
                                                type="file"
                                                className="form-control"
                                                onChange={(e) => {
                                                    let filename = `dprDocument`;
                                                    let path = "/Uploads/AffiliationPDFs/2023/";
                                                    ImagePdfBucket(e, ApplicationFormik, path, `dprDocument`, filename, "pdf");
                                                }}
                                            />
                                            <ErrorMessage name="dprDocument" component="div" className="text-danger" />
                                        </td>
                                    </tr>

                                    {/* 7.2 */}
                                    <tr>
                                        <td>2</td>
                                        <td>Development Plan for the College</td>
                                        <td>
                                            <input
                                                type="file"
                                                className="form-control"
                                                onChange={(e) => {
                                                    let filename = `developmentPlanDoc`;
                                                    let path = "/Uploads/AffiliationPDFs/2023/";
                                                    ImagePdfBucket(e, ApplicationFormik, path, `developmentPlanDoc`, filename, "pdf");
                                                }}
                                            />
                                            <ErrorMessage name="developmentPlanDoc" component="div" className="text-danger" />
                                        </td>
                                    </tr>

                                    {/* 7.3 */}
                                    <tr>
                                        {/* <td>3</td> */}
                                        <td colSpan={3}>Architectural Master Plan</td>
                                        {/* <td>
                                            <input
                                                type="file"
                                                className="form-control"
                                                onChange={(e) =>
                                                    ApplicationFormik.setFieldValue("architecturalPlanDoc", e.target.files[0])
                                                }
                                            />
                                            <ErrorMessage name="architecturalPlanDoc" component="div" className="text-danger" />
                                        </td> */}
                                    </tr>

                                    {/* 7.4 */}
                                    <tr>
                                        <td>3</td>
                                        <td>Structure of Academic Administrative Governance</td>
                                        <td>
                                            <input
                                                type="file"
                                                className="form-control"
                                                onChange={(e) => {
                                                    let filename = `governanceStructureDoc`;
                                                    let path = "/Uploads/AffiliationPDFs/2023/";
                                                    ImagePdfBucket(e, ApplicationFormik, path, `governanceStructureDoc`, filename, "pdf");
                                                }}
                                            />
                                            <ErrorMessage name="governanceStructureDoc" component="div" className="text-danger" />
                                        </td>
                                    </tr>

                                    {/* 7.5 */}
                                    <tr>
                                        <td>4</td>
                                        <td>Sources of Financing</td>
                                        <td>
                                            <input
                                                type="file"
                                                className="form-control"
                                                onChange={(e) => {
                                                    let filename = `financeSourceDoc`;
                                                    let path = "/Uploads/AffiliationPDFs/2023/";
                                                    ImagePdfBucket(e, ApplicationFormik, path, `financeSourceDoc`, filename, "pdf");
                                                }}
                                            />
                                            <ErrorMessage name="financeSourceDoc" component="div" className="text-danger" />
                                        </td>
                                    </tr>

                                    {/* 7.6 */}
                                    <tr>
                                        <td>5</td>
                                        <td>Policies on Faculty Recruitment & Development</td>
                                        <td>
                                            <input
                                                type="file"
                                                className="form-control"
                                                onChange={(e) => {
                                                    let filename = `facultyPoliciesDoc`;
                                                    let path = "/Uploads/AffiliationPDFs/2023/";
                                                    ImagePdfBucket(e, ApplicationFormik, path, `facultyPoliciesDoc`, filename, "pdf");
                                                }}
                                            />
                                            <ErrorMessage name="facultyPoliciesDoc" component="div" className="text-danger" />
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                        {/* ================= SUBMIT ================= */}
                        <div className="text-end mt-4">
                            <button type="submit" className="btn btn-primary">
                                Submit
                            </button>
                        </div>

                    </Form>
                </FormikProvider>

            </div>
        </div >
    );
}